import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { DynamicProductVoucherDialogContent } from './DynamicProductVoucherDialogContent'

type ProductVoucherInteractiveLabelDialogProps = {
  isOpen: boolean
  legalText?: string
  onClose: () => void
  voucher: string
}

export const ProductVoucherInteractiveLabelDialog: FC<
  ProductVoucherInteractiveLabelDialogProps
> = ({ isOpen, legalText, onClose, voucher }) => {
  return (
    <Dialog
      data-qa-id="product-voucher-explainer"
      onClose={onClose}
      open={isOpen}
    >
      <DialogTitle onClose={onClose}>
        <FormattedMessage id="product.voucher.details.heading" />
      </DialogTitle>
      <DialogContent>
        <DynamicProductVoucherDialogContent
          legalText={legalText}
          voucher={voucher}
        />
      </DialogContent>
    </Dialog>
  )
}
